// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignInUpForm_SignupBox__cEXo3 {
  background-color: #353839;
  width: 100%; 
  height: 600px;
  background-color: #000;
}

.SignInUpForm_FillerImagel__g13kM {
  object-fit: cover;
  height: 350px;
  width: 5px;
} 

.SignInUpForm_Inner__7cEgr {
  background-color: #0b3d63;
  color: #fafafa;
}

.SignInUpForm_Guest__HlA58 {
  color: #fafafa;
}

.SignInUpForm_Form__AzLrL {
  background-color: #3b444b;
  padding: 10px;
  background-color: #202426;
}


.SignInUpForm_Input__M3Dq3 {
    background: #3b444b;
    box-sizing: border-box;
    border-bottom:  1px solid #fff;
    border-top: 1px solid #3b444b;
    border-left: 1px solid #3b444b;
    border-right: 1px solid #3b444b;
    color: #fff;
    text-align: center;
    padding: 10px;
}

.SignInUpForm_Header__VpCjw {
    font-style: normal;
    font-weight: bold;
    /* font-size: 16px;
    line-height: 19px; */
    text-align: center;
    /* letter-spacing: 0.2em; */
    text-transform: uppercase;
    color: #2142b2;
}

.SignInUpForm_Link__nTDsh {
    text-decoration: none;
    text-align: center;
    display: block;
    margin: auto;
    color: antiquewhite;
}

.SignInUpForm_Link__nTDsh span {
  color: rgb(170 231 255);
}

.SignInUpForm_Container__\\+q41T {
  padding: 30px 10px;
}

@media screen and (max-width: 600px) {
.SignInUpForm_FillerImagel__g13kM {
  width: 3px;
} 
}`, "",{"version":3,"sources":["webpack://./src/styles/SignInUpForm.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;AAC3B;;;AAGA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;wBACoB;IACpB,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;AACA;EACE,UAAU;AACZ;AACA","sourcesContent":[".SignupBox {\n  background-color: #353839;\n  width: 100%; \n  height: 600px;\n  background-color: #000;\n}\n\n.FillerImagel {\n  object-fit: cover;\n  height: 350px;\n  width: 5px;\n} \n\n.Inner {\n  background-color: #0b3d63;\n  color: #fafafa;\n}\n\n.Guest {\n  color: #fafafa;\n}\n\n.Form {\n  background-color: #3b444b;\n  padding: 10px;\n  background-color: #202426;\n}\n\n\n.Input {\n    background: #3b444b;\n    box-sizing: border-box;\n    border-bottom:  1px solid #fff;\n    border-top: 1px solid #3b444b;\n    border-left: 1px solid #3b444b;\n    border-right: 1px solid #3b444b;\n    color: #fff;\n    text-align: center;\n    padding: 10px;\n}\n\n.Header {\n    font-style: normal;\n    font-weight: bold;\n    /* font-size: 16px;\n    line-height: 19px; */\n    text-align: center;\n    /* letter-spacing: 0.2em; */\n    text-transform: uppercase;\n    color: #2142b2;\n}\n\n.Link {\n    text-decoration: none;\n    text-align: center;\n    display: block;\n    margin: auto;\n    color: antiquewhite;\n}\n\n.Link span {\n  color: rgb(170 231 255);\n}\n\n.Container {\n  padding: 30px 10px;\n}\n\n@media screen and (max-width: 600px) {\n.FillerImagel {\n  width: 3px;\n} \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SignupBox": `SignInUpForm_SignupBox__cEXo3`,
	"FillerImagel": `SignInUpForm_FillerImagel__g13kM`,
	"Inner": `SignInUpForm_Inner__7cEgr`,
	"Guest": `SignInUpForm_Guest__HlA58`,
	"Form": `SignInUpForm_Form__AzLrL`,
	"Input": `SignInUpForm_Input__M3Dq3`,
	"Header": `SignInUpForm_Header__VpCjw`,
	"Link": `SignInUpForm_Link__nTDsh`,
	"Container": `SignInUpForm_Container__+q41T`
};
export default ___CSS_LOADER_EXPORT___;
